import { MutationOptions, useRepositoryMutation } from '@mews-commander/data-access';

export const useScheduleExportReservations = (options: MutationOptions<'guestInHouse', 'scheduleExportReservations'>) =>
    useRepositoryMutation('guestInHouse', 'scheduleExportReservations', options);
